import { Checkbox } from 'src/components/Checkbox';

type DaySelectorProps = {
  value: string[];
  setValue: (value: string[]) => void;
};

export const daysOfWeek = [
  { id: 'monday', label: 'Monday' },
  { id: 'tuesday', label: 'Tuesday' },
  { id: 'wednesday', label: 'Wednesday' },
  { id: 'thursday', label: 'Thursday' },
  { id: 'friday', label: 'Friday' },
  { id: 'saturday', label: 'Saturday' },
  { id: 'sunday', label: 'Sunday' },
];

export function DaySelector({ value, setValue }: DaySelectorProps) {
  const handleDayToggle = (day: string) => {
    let newDays = [...value];
    if (value.includes(day)) {
      // Remove the day
      newDays = newDays.filter((d) => d !== day);
    } else {
      // Add the day
      newDays = [...newDays, day];
    }

    setValue(newDays);
  };

  return (
    <div className="flex flex-wrap gap-y-2">
      {daysOfWeek.map((day) => (
        <div key={day.id} className="flex items-center space-x-1 mr-8">
          <Checkbox
            id={`day-${day.id}`}
            ariaLabel={`Select ${day.label}`}
            checked={value.includes(day.id)}
            onChange={() => handleDayToggle(day.id)}
          />
          <label htmlFor={`day-${day.id}`} className="text-sm">
            {day.label}
          </label>
        </div>
      ))}
    </div>
  );
}
